module.exports = __webpack_public_path__ + "img/245f84a.png";